var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.3125C10.5895 0.3125 8.23322 1.02728 6.22899 2.36646C4.22477 3.70564 2.66267 5.60907 1.74022 7.83605C0.817781 10.063 0.576427 12.5135 1.04668 14.8777C1.51694 17.2418 2.67769 19.4134 4.38214 21.1179C6.08659 22.8223 8.2582 23.9831 10.6223 24.4533C12.9865 24.9236 15.437 24.6822 17.664 23.7598C19.8909 22.8373 21.7944 21.2752 23.1335 19.271C24.4727 17.2668 25.1875 14.9105 25.1875 12.5C25.1813 9.26958 23.8953 6.17324 21.611 3.88898C19.3268 1.60472 16.2304 0.318695 13 0.3125ZM16.9141 13.1914L12.2266 17.4102C12.0526 17.5665 11.8276 17.654 11.5938 17.6562C11.4636 17.6569 11.3347 17.6302 11.2156 17.5777C11.0964 17.5251 10.9897 17.4481 10.9023 17.3516C10.7346 17.1682 10.6465 16.9256 10.6575 16.6773C10.6685 16.429 10.7776 16.1952 10.9609 16.0273L14.875 12.5L10.9609 8.97266C10.7837 8.80328 10.6799 8.57124 10.6718 8.32625C10.6636 8.08127 10.7517 7.84282 10.9172 7.66199C11.0827 7.48117 11.3124 7.37236 11.5571 7.35887C11.8019 7.34539 12.0422 7.4283 12.2266 7.58984L16.9141 11.8086C17.01 11.8964 17.0866 12.0033 17.139 12.1223C17.1914 12.2413 17.2184 12.3699 17.2184 12.5C17.2184 12.6301 17.1914 12.7587 17.139 12.8777C17.0866 12.9967 17.01 13.1036 16.9141 13.1914Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrow);
export default __webpack_public_path__ + "static/media/menuArrow.92a28ec1391e3b3d36cfd1cabc5aa1c6.svg";
export { ForwardRef as ReactComponent };